import { Col, Row, Button, Icon, Input, Select, Popconfirm } from 'antd';
import React, { ChangeEventHandler } from 'react';
import styled from 'styled-components';
import { UserStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import consultaStore, { ConsultaStore } from '../../stores/consultaStore';

const Container = styled.div`
    padding: 15px;
    position: relative;
    background-color: #ebe7e0;
`;
const InputStyled = styled(Input)`
    height: 35px !important;
    padding: 10px 14px !important;
    margin-bottom: 18px !important;
`;

const ColStyled = styled(Col)`
    padding-right: 10px !important;
`;

interface UsuarioCardAltaProps {
    userStore?: UserStore;
    consultaStore?: ConsultaStore;
}

@inject('consultaStore')
@inject('userStore')
@observer
export class UsuarioCardAlta extends React.Component<UsuarioCardAltaProps> {
    nombreChange: ChangeEventHandler<HTMLInputElement> = event => {
        const { userStore } = this.props;
        userStore!.usuarioAlta!.nombre = event.target.value;
    };

    emailChange: ChangeEventHandler<HTMLInputElement> = event => {
        const { userStore } = this.props;
        userStore!.usuarioAlta!.email = event.target.value;
    };

    usuarioChange: ChangeEventHandler<HTMLInputElement> = event => {
        const { userStore } = this.props;
        userStore!.usuarioAlta!.usuarioAcceso = event.target.value;
    };

    renderRol = () => {
        const { consultaStore, userStore } = this.props;
        return (
            <Select
                style={{ width: '100%', height: '35px', marginBottom: '18px' }}
                placeholder="Seleccione"
                onChange={this.changeRol}
                defaultValue={userStore!.tipoModal != 'Alta' ? userStore!.usuarioAlta!.idRol : '0'}
                value={userStore!.usuarioAlta!.idRol}
            >
                <Select.Option key={0}>Seleccione</Select.Option>
                {consultaStore!.roles.map(r => (
                    <Select.Option key={r.id}>{r.nombre}</Select.Option>
                ))}
            </Select>
        );
    };

    changeRol = async (value: any) => {
        const { userStore } = this.props;
        userStore!.usuarioAlta!.idRol = value;
    };

    renderCargo = () => {
        const { consultaStore, userStore } = this.props;
        return (
            <Select
                style={{ width: '100%', height: '35px', marginBottom: '18px' }}
                placeholder="Todos"
                onChange={this.changeCargo}
                defaultValue={
                    userStore!.tipoModal != 'Alta' ? userStore!.usuarioAlta!.idCargo : '0'
                }
                value={userStore!.usuarioAlta!.idCargo}
            >
                <Select.Option key={0}>Todos</Select.Option>
                {consultaStore!.cargos.map(r => (
                    <Select.Option key={r.id}>{r.nombre}</Select.Option>
                ))}
            </Select>
        );
    };

    changeCargo = async (value: any) => {
        const { userStore } = this.props;
        userStore!.usuarioAlta!.idCargo = value;
    };

    renderMunicipio = () => {
        const { userStore } = this.props;
        return (
            <Select
                showSearch={true}
                style={{ width: '100%' }}
                placeholder="Todos"
                optionFilterProp="children"
                onChange={this.handleMunicipio}
                value={userStore!.usuarioAlta!.municipio}
            >
                <Select.Option key={'0'}>Todos</Select.Option>
                {this.props.consultaStore!.listaMunicipios.map(municipio => (
                    <Select.Option key={municipio.id}>{municipio.nombre}</Select.Option>
                ))}
            </Select>
        );
    };

    handleMunicipio = (value: any) => {
        const { userStore } = this.props;
        userStore!.usuarioAlta.municipio = value;
    };

    renderOperador = () => {
        return (
            <Select
                showSearch={true}
                style={{ width: '100%' }}
                placeholder="Todos"
                optionFilterProp="children"
                onChange={this.handleOperador}
            >
                <Select.Option key={'0'}>Todos</Select.Option>
                {this.props.consultaStore!.listaOrganismos.map(organismo => (
                    <Select.Option key={organismo.ooId}>{organismo.nombre}</Select.Option>
                ))}
            </Select>
        );
    };

    handleOperador = (value: any) => {
        const { userStore } = this.props;
        userStore!.usuarioAlta.municipio = value;
    };

    clickCancelar = () => {
        const { userStore } = this.props;
        userStore!.openModal = false;
        userStore!.limpiarUsuarioAlta();
    };

    clickEditar = () => {
        const { userStore } = this.props;
        userStore!.tipoModal = 'Editar';
    };

    clickRegistrar = async () => {
        const { userStore } = this.props;
        await userStore!.registrarUsuario();
    };

    clickEliminar = async () => {
        const { userStore } = this.props;
        await userStore!.eliminarUsuario();
    };

    clickGuardar = async () => {
        const { userStore } = this.props;
        await userStore!.editarUsuario();
    };

    clickRestablecerPassword = async () => {
        const { userStore } = this.props;
        await userStore!.restablecerPassword();
    };

    clickGenerarActa = async () => {
        const { userStore } = this.props;
        const response = await userStore!.getResponsiva(userStore!.idUsuariConsulta);
        if (!response) {
            return;
        }
        const type = 'application/pdf';
        const blob = new Blob([response!.data], { type });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = userStore!.usuarioAlta!.usuarioAcceso;
        link.href = url;
        link.click();
        const newWindow = window.open('/');
        newWindow!.onload = () => {
            newWindow!.location.replace(url);
        };
        const fileDownload = require('react-file-download');
        fileDownload(blob, userStore!.usuarioAlta!.usuarioAcceso + '.pdf');
    };

    render() {
        const stylePrimary = {
            backgroundColor: '#a8123e',
            borderColor: '#a8123e',
            color: '#fff',
            marginRight: '10px'
        };
        const styleVeda = {
            backgroundColor: '#3c3c3b',
            borderColor: '#3c3c3b',
            color: '#fff',
            marginRight: '10px'
        };
        const { userStore } = this.props;

        return (
            <>
                <Container>
                    <Row style={{ textAlign: 'center' }}>
                        {userStore!.tipoModal == 'Alta' ? (
                            <h2>Alta de usuario</h2>
                        ) : userStore!.tipoModal == 'Editar' ? (
                            <h2>Editar usuario</h2>
                        ) : (
                            <h2>Consulta de usuario</h2>
                        )}
                    </Row>
                    <Row>
                        <ColStyled span={12}>
                            {userStore!.tipoModal == 'Consulta' ||
                            userStore!.tipoModal == 'Editar' ? (
                                <>
                                    <strong>Nombre: </strong>
                                    {userStore!.usuarioAlta!.nombre}
                                </>
                            ) : (
                                <InputStyled
                                    placeholder="Nombre"
                                    value={userStore!.usuarioAlta!.nombre}
                                    onChange={this.nombreChange}
                                />
                            )}
                        </ColStyled>
                        <ColStyled span={12}>
                            {userStore!.tipoModal == 'Consulta' ? (
                                <>
                                    <strong>Correo: </strong>
                                    {userStore!.usuarioAlta!.email}
                                </>
                            ) : (
                                <InputStyled
                                    placeholder="Email"
                                    onChange={this.emailChange}
                                    value={userStore!.usuarioAlta!.email}
                                />
                            )}
                        </ColStyled>
                    </Row>
                    <Row>
                        <ColStyled span={8}>
                            {userStore!.tipoModal == 'Consulta' ||
                            userStore!.tipoModal == 'Editar' ? (
                                <>
                                    <strong>Usuario: </strong>
                                    {userStore!.usuarioAlta!.usuarioAcceso}
                                </>
                            ) : (
                                <InputStyled
                                    placeholder="Usuario"
                                    onChange={this.usuarioChange}
                                    value={userStore!.usuarioAlta!.usuarioAcceso}
                                />
                            )}
                        </ColStyled>
                        <ColStyled span={8}>
                            {userStore!.tipoModal == 'Consulta' ||
                            userStore!.tipoModal == 'Editar' ? null : (
                                <>
                                    <strong>Contraseña: </strong>
                                    {userStore!.usuarioAlta!.usuarioAcceso}
                                </>
                            )}
                        </ColStyled>
                    </Row>
                    <Row>
                        <ColStyled span={12}>
                            {userStore!.tipoModal == 'Alta' ? (
                                this.renderRol()
                            ) : (
                                <>
                                    <strong>Rol: </strong>
                                    {userStore!.usuarioAlta!.rolNombre}
                                </>
                            )}
                        </ColStyled>
                        <ColStyled span={12}>
                            {userStore!.tipoModal == 'Consulta' ? (
                                <>
                                    <strong>Cargo: </strong>
                                    {userStore!.usuarioAlta!.cargoNombre}
                                </>
                            ) : (
                                this.renderCargo()
                            )}
                        </ColStyled>
                    </Row>
                    <Row>
                        {userStore!.tipoModal == 'Consulta' || userStore!.tipoModal == 'Editar' ? (
                            <strong>{userStore!.usuarioAlta!.municipio}</strong>
                        ) : userStore!.usuarioAlta!.idRol == '5' ? (
                            <ColStyled>{this.renderMunicipio()}</ColStyled>
                        ) : userStore!.usuarioAlta!.idRol == '4' ? (
                            <ColStyled>{this.renderOperador()}</ColStyled>
                        ) : null}
                    </Row>
                    <Row style={{ paddingTop: '20px', textAlign: 'right' }}>
                        <Button
                            onClick={this.clickCancelar}
                            type="danger"
                            style={{ marginRight: '10px' }}
                        >
                            Cancelar
                        </Button>
                        {userStore!.tipoModal == 'Alta' ? (
                            <Button onClick={this.clickRegistrar} style={styleVeda}>
                                Registrar
                            </Button>
                        ) : userStore!.tipoModal == 'Consulta' ? (
                            <>
                                <Button
                                    onClick={this.clickEditar}
                                    style={{
                                        // backgroundColor: '#a5987e',
                                        // VEDA
                                        backgroundColor: '#a7a7a7',
                                        color: '#ffffff',
                                        marginRight: '10px'
                                    }}
                                >
                                    <Icon type="form" />
                                    Editar
                                </Button>

                                {userStore!.rol != 'ROL-JADP' ? (
                                    <Button
                                        onClick={this.clickGenerarActa}
                                        style={{
                                            backgroundColor: '#636569',
                                            color: '#ffffff',
                                            marginRight: '10px'
                                        }}
                                    >
                                        <Icon type="file-pdf" />
                                        Generar Acta
                                    </Button>
                                ) : null}
                                <Popconfirm
                                    title={
                                        '¿Desea eliminar el usuario ' +
                                        userStore!.usuarioAlta!.usuarioAcceso +
                                        '?'
                                    }
                                    onConfirm={this.clickEliminar}
                                    placement="bottom"
                                    cancelText="Cancelar"
                                    okText="Aceptar"
                                >
                                    <Button
                                        style={{
                                            // backgroundColor: '#a8123e',
                                            // VEDA
                                            backgroundColor: '#3c3c3b',
                                            color: '#ffffff',
                                            marginRight: '10px'
                                        }}
                                    >
                                        <Icon type="delete" />
                                        Eliminar
                                    </Button>
                                </Popconfirm>
                            </>
                        ) : (
                            <>
                                <Button
                                    onClick={this.clickRestablecerPassword}
                                    style={{
                                        backgroundColor: '#a5987e',
                                        color: '#ffffff',
                                        marginRight: '10px'
                                    }}
                                >
                                    <Icon type="rollback" />
                                    Restablecer Contraseña
                                </Button>
                                <Button onClick={this.clickGuardar} style={styleVeda}>
                                <Icon type="save" />
                                    Guardar
                                </Button>
                            </>
                        )}
                    </Row>
                </Container>
            </>
        );
    }
}
